import { render, staticRenderFns } from "./DetailTable.vue?vue&type=template&id=39b9422e&scoped=true"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"
import style0 from "./DetailTable.vue?vue&type=style&index=0&id=39b9422e&prod&lang=scss&scoped=true"
import style1 from "./DetailTable.vue?vue&type=style&index=1&id=39b9422e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9422e",
  null
  
)

export default component.exports